var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap"},[_c('Header'),_c('official-seal'),_c('Bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }